import { colors } from '@fs/zion-ui'

/* if the hex value is used over zion colors I couldn't find it in zion colors readily from figma styles
nightfall is a work in progress, an updated to v10 colors will be required
*/
const nightFall = false

export const defaultFills = {
  base: colors.gray00,
  midLight: colors.gray00,
  light: colors.gray00,
  dark15: colors.gray00,
  lessDark: colors.gray00,
  light05: colors.gray00,
  light02: colors.gray00,
}

const myStoryNightfallFills = {
  base: '#121212',
  midLight: '#FFD06A',
  light: colors.yellow05,
  dark15: colors.yellow20,
  lessDark: colors.yellow10,
  light05: colors.yellow05,
  light02: colors.yellow02,
}

const myStoryDaybreakFills = {
  base: colors.gray00,
  midLight: '#FFD06A',
  light: colors.yellow05,
  dark15: colors.yellow20,
  lessDark: colors.yellow10,
  light05: colors.yellow05,
  light02: colors.yellow02,
}

const myStorySimpleDaybreakFills = {
  gradient1: colors.blue20,
  gradient2: colors.blue05,
  clouds1: '#daf3f9',
  clouds2: '#c3ecf5',
}

const myFamilyDaybreakFills = {
  base: colors.gray00,
  midLight: '#CDE797',
  light: '#E1EFC2',
  dark15: '#96C331',
  lessDark: '#B1D958',
  light05: colors.green05,
  light02: colors.green02,
}

const myFamilyNightfallFills = {
  base: '#121212',
  midLight: '#CDE797',
  light: '#2A4020',
  dark15: colors.green20,
  lessDark: '#B1D958',
  light05: colors.green05,
  light02: colors.green02,
}

const myTempleDaybreakFills = {
  base: colors.gray00,
  midLight: colors.blue10,
  light: colors.blue05,
  dark15: colors.blue30,
  lessDark: colors.blue20,
  light05: colors.blue05,
  light02: colors.blue02,
}

const myTempleNightfallFills = {
  base: '#121212',
  midLight: colors.blue10,
  light: colors.blue05,
  dark15: colors.blue30,
  lessDark: colors.blue20,
  light05: colors.blue05,
  light02: colors.blue02,
}

const myGamesDaybreakFills = {
  base: colors.gray00,
  midLight: '#FFC7BF',
  light: colors.red05,
  dark15: '#FF8B84',
  lessDark: '#FFACA0',
  light05: colors.red05,
  light02: colors.red02,
}

const myGamesNightfallFills = {
  base: '#121212',
  midLight: '#FFC7BF',
  light: colors.red05,
  dark15: '#FF8B84',
  lessDark: '#FFACA0',
  light05: colors.red05,
  light02: colors.red02,
}

const leaderboardDaybreakFills = {
  base: colors.gray00,
  midLight: '#F9C636',
  light: colors.yellow05,
  dark15: colors.yellow02,
  lessDark: '#F1AB0D',
  light05: colors.yellow05,
  light02: colors.yellow02,
}

const leaderboardNightfallFills = {
  base: '#121212',
  midLight: '#FFC7BF',
  light: colors.red05,
  dark15: '#FF8B84',
  lessDark: '#FFACA0',
  light05: colors.red05,
  light02: colors.red02,
}

export const myStoryFills = nightFall ? myStoryNightfallFills : myStoryDaybreakFills
export const myStorySimpleFills = nightFall ? myStoryNightfallFills : myStorySimpleDaybreakFills
export const myFamilyFills = nightFall ? myFamilyNightfallFills : myFamilyDaybreakFills
export const myTempleFills = nightFall ? myTempleNightfallFills : myTempleDaybreakFills
export const myGamesFills = nightFall ? myGamesNightfallFills : myGamesDaybreakFills
export const leaderboardFills = nightFall ? leaderboardNightfallFills : leaderboardDaybreakFills
